"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExecutionDataView = void 0;
var tslib_1 = require("tslib");
var base_1 = require("../base");
var useDataView_1 = require("./useDataView");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var createExecution_1 = require("./createExecution");
/**
 * @internal
 */
function isExecutionConfiguration(obj) {
    var _a;
    return !isEmpty_1.default(obj) && !!((_a = obj) === null || _a === void 0 ? void 0 : _a.seriesBy);
}
/**
 * React hook to get data for a specific execution.
 *
 * @public
 */
function useExecutionDataView(config, deps) {
    var _a;
    var execution = config.execution, window = config.window, onCancel = config.onCancel, onError = config.onError, onLoading = config.onLoading, onPending = config.onPending, onSuccess = config.onSuccess;
    var backend = base_1.useBackendStrict(config.backend, "useExecutionDataView");
    var workspace = base_1.useWorkspaceStrict(config.workspace, "useExecutionDataView");
    var effectiveDeps = deps !== null && deps !== void 0 ? deps : [];
    var propsToResolve = getExecutionConfigurationProps(config.execution);
    var _b = tslib_1.__read(base_1.useResolveValuesWithPlaceholders([
        propsToResolve.seriesBy,
        propsToResolve.slicesBy,
        propsToResolve.totals,
        propsToResolve.filters,
        propsToResolve.sortBy,
    ], propsToResolve.placeholdersResolutionContext), 5), seriesBy = _b[0], slicesBy = _b[1], totals = _b[2], filters = _b[3], sortBy = _b[4];
    var preparedExecution = isExecutionConfiguration(execution)
        ? createExecution_1.createExecution(tslib_1.__assign(tslib_1.__assign({}, execution), { seriesBy: seriesBy, slicesBy: slicesBy,
            totals: totals,
            filters: filters,
            sortBy: sortBy,
            backend: backend,
            workspace: workspace }))
        : execution;
    return useDataView_1.useDataView({ execution: preparedExecution, window: window, onCancel: onCancel, onError: onError, onLoading: onLoading, onPending: onPending, onSuccess: onSuccess }, tslib_1.__spread([
        backend,
        workspace,
        (_a = preparedExecution === null || preparedExecution === void 0 ? void 0 : preparedExecution.fingerprint()) !== null && _a !== void 0 ? _a : "__executionFingerprint__"
    ], effectiveDeps));
}
exports.useExecutionDataView = useExecutionDataView;
/**
 * @internal
 */
function getExecutionConfigurationProps(execution) {
    if (isExecutionConfiguration(execution)) {
        return execution;
    }
    return {};
}
//# sourceMappingURL=useExecutionDataView.js.map